// utils/crypto.ts
import axios from 'axios';

const MAIN_BASE = "https://crypto.adpumb.com";
const FALLBACK_URL = "https://api.blockchain.info/stats";

// Optional: Configure axios instance with default settings
const cryptoApi = axios.create({
  timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Get crypto info with fallback
 * Returns: { priceUsd, difficulty }
 */
export async function getCryptoInfo(coin: string) {
  try {
    // --- PRIMARY API ---
    const response = await cryptoApi.get(`${MAIN_BASE}/${coin}/info`);
    const data = response.data;

    return {
      priceUsd: data.btcPriceInUsd,
      difficulty: data.difficulty,
    };
  } catch (e) {
    console.warn("⚠ Primary API failed, using fallback…");

    try {
      // --- FALLBACK API ---
      const response = await cryptoApi.get(FALLBACK_URL);
      const data = response.data;

      return {
        priceUsd: data.market_price_usd,
        difficulty: data.difficulty,
      };
    } catch (fallbackError) {
      console.error("Both primary and fallback APIs failed:", fallbackError);
      throw new Error("Failed to fetch crypto information from all available sources");
    }
  }
}

/**
 * Convert crypto → currency
 * Falls back to priceUsd from fallback if needed
 */
export async function convert(
  from: string,
  to: string,
  value: number
) {
  try {
    // PRIMARY API
    const response = await cryptoApi.get(
      `${MAIN_BASE}/convert`,
      {
        params: {
          from,
          to,
          value
        }
      }
    );
    
    return response.data; // { from, to, value, result }
  } catch (e) {
    console.warn("⚠ Convert API failed, using fallback price…");

    // FALLBACK:
    const info = await getCryptoInfo(from);

    return {
      from: from.toUpperCase(),
      to: to.toUpperCase(),
      value,
      result: info.priceUsd * value,
    };
  }
}